<template>
  <div class="page">
    <h3>结算方式</h3>
    <div class="weui-cell weui-cell_active" >
      <div class="weui-cell__hd"><label class="weui-label">站点</label></div>
      <div class="weui-cell__bd weui-flex">
          <input class="weui-input" autofocus type="text" pattern="[0-9]*" @click="pickPos()" placeholder="请输入16位数卡号" maxlength="16" :value="selPos.label" />
          <button class="weui-btn_reset weui-btn_icon weui-btn_input-clear">
            <i class="weui-icon-clear"></i>
          </button>
      </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_switch">
        <div class="weui-cell__bd"><label class="weui-label">微信</label></div>
        <div class="weui-cell__ft">
            <label for="switch_KX" class="weui-switch-cp">
                <input id="switch_KX" class="weui-switch-cp__input" type="checkbox" checked="checked"/>
                <div class="weui-switch-cp__box" @click="clickSwitch(4)"></div>
            </label>
        </div>
    </div>
    
    <div class="weui-cell weui-cell_active" v-if="kx">
      <div class="weui-cell__hd"><label class="weui-label">微信商户号</label></div>
      <div class="weui-cell__bd weui-flex">
          <input  class="weui-input  right" autofocus type="text" pattern="[0-9]*" placeholder="输入快洗门市价" maxlength="16" value="28"/>
      </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_switch">
        <div class="weui-cell__bd"><label class="weui-label">支付宝</label></div>
        <div class="weui-cell__ft">
            <label for="switch_JX" class="weui-switch-cp">
                <input id="switch_JX" class="weui-switch-cp__input" type="checkbox" checked="checked"/>
                <div class="weui-switch-cp__box" @click="clickSwitch(2)"></div>
            </label>
        </div>
    </div>
    
    <div class="weui-cell weui-cell_active" v-if="jx">
      <div class="weui-cell__hd"><label class="weui-label">支付宝商户号</label></div>
      <div class="weui-cell__bd weui-flex">
          <input  class="weui-input  right" autofocus type="text" pattern="[0-9]*" placeholder="输入快洗门市价" maxlength="16" value="35"/>
      </div>
    </div>

    <div class="weui-cell weui-cell_active weui-cell_switch">
        <div class="weui-cell__bd"><label class="weui-label">链点</label></div>
        <div class="weui-cell__ft">
            <label for="switch_CX" class="weui-switch-cp">
                <input id="switch_CX" class="weui-switch-cp__input" type="checkbox" checked="checked"/>
                <div class="weui-switch-cp__box" @click="clickSwitch(1)"></div>
            </label>
        </div>
    </div>
    
    <div class="weui-cell weui-cell_active" v-if="cx">
      <div class="weui-cell__hd"><label class="weui-label">链点</label></div>
      <div class="weui-cell__bd weui-flex">
          <input  class="weui-input  right" autofocus type="text" pattern="[0-9]*" placeholder="输入快洗门市价" maxlength="16" value="60"/>
      </div>
    </div>
</div>
<!--
<div class="page">
    <div class="page__hd">
        <h1 class="page__title">Picker</h1>
        <p class="page__desc">多列选择器，需要配合js实现</p>
    </div>
    <div class="page__bd page__bd_spacing">
        <a href="javascript:" class="weui-btn weui-btn_default" id="showPicker">单列选择器</a>
        <a href="javascript:" class="weui-btn weui-btn_default" id="showDatePicker">日期选择器</a>
    </div>
</div>
-->


</template>

<script>
  import JQ from 'jquery'
  import pieGraph from '../components/pie.vue'
  
  import 'bootstrap/dist/css/bootstrap.css'
  
  export default {
  
    data () {
      return {
        kx:true,
        cx:true,
        jx:true,
        beginHour : 0,
        endHour: 24,
        dateStr : new Date().Format("yyyy-MM-dd"),
        selPos: {'label':'缺省','value':'000'}
      }
    },
    mounted() {
      const {name,xData,yData} = this
         console.log(this.$refs)
         // this.$refs.chart_line_one.initChart(name,xData,yData)
         //this.$refs.chart_line_box.initChart(name,xData,yData)
      
    },
    methods: {
      clickSwitch(evt){
        console.log(evt);
        switch(evt){
          case 4: this.kx = ! this.kx; break;
          case 2: this.jx = ! this.jx; break;
          case 1: this.cx = ! this.cx; break;
        }
        
      },
      pickHour(flag) {
        let that = this;
        let optionHour = [];
        for(var i=0;i<=24;i++){
          optionHour.push({"label":i,"value":i});
        }
        this.$weui.picker(optionHour, {
                onChange: function (result) {
                    console.log(result,result[0]);
                    if(flag) that.beginHour = result[0].value;
                    else that.endHour = result[0].value;
                },
                onConfirm: function (result) {
                    console.log(result,result[0]); 
                    if(flag) that.beginHour = result[0].value;
                    else that.endHour = result[0].value;
                },
                title: '单列选择器'
            });
      },
      pickPos() {
        let that = this;
        this.$weui.picker([{
                label: 'P2022090002',
                value: 'P2022090002'
            }, {
                label: 'P2022090003',
                value: 'P2022090002'
            }, {
                label: 'P2022090005',
                value: 'P2022090002'
            },{
                label: 'P2022090004 (disabled)',
                disabled: true,
                value: 3
            }, {
                label: 'P2022090001',
                value: 4
            }], {
                onChange: function (result) {
                    console.log(result,result[0]);
                    that.selPos = result[0];
                },
                onConfirm: function (result) {
                    console.log(result);
                    that.selPos = result[0];
                },
                title: '单列选择器'
            });
        },
        pickerDate() {
        let that = this;
        this.$weui.datePicker({
              start: 1990,
              end: new Date().getFullYear(),
              onChange: function (result) {
                  console.log(result);
                  console.log(result[0].value +"-"+ result[1].value +"-"+ result[2].value );
                  that.dateStr = result[0].value +"-"+ result[1].value +"-"+ result[2].value;
              },
              onConfirm: function (result) {
                  console.log(result);
              },
              title: '多列选择器'
          });
      },
      handleClick () {
        this.$weui.dialog({
          title: '提示',
          content: '是否领取礼品',
          buttons: [{
              label: '取消',
              type: 'default',
              onClick: () => {
                console.log('您已取消领取礼品！')
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {
              console.log('您已确定领取礼品！')
              }
            }
          ]
        })
      }
    }
  }
  </script>

  <style>
    input.right{align-content: right;text-align: right;align-self: right;width:3em}
    input.center{align-content: center;text-align: center;align-self: center;width:3em}
  </style>


// WEBPACK FOOTER //
// src/views/config_pay.vue